import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ } from "@/modules/premiere-video/resources";

export function FaqList({ prefix = "faq", items = FAQ }) {
  return (
    <Accordion type="single" collapsible className="rounded-[18px] border border-line bg-white px-5 sm:px-7" data-testid={`${prefix}-accordion`}>
      {items.map((f, i) => (
        <AccordionItem key={f.q} value={`q${i}`} className="border-line last:border-0">
          <AccordionTrigger className="py-5 text-left font-medium text-ink hover:no-underline [&>svg]:text-bx" data-testid={`${prefix}-question-${i + 1}`}>{f.q}</AccordionTrigger>
          <AccordionContent className="pb-5 text-base leading-relaxed text-soft">{f.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
